<app-pageheader [Parent]="this">
  <add-button AddRoute="/enforcement/printers/new/edit"></add-button>
</app-pageheader>

<app-datalistview [Columns]="Columns" [ShowMap]="false" ApiUrl="enforcement/printers/searches"
  [AllowEdit]="true" EditUrl="enforcement/citations/printers/:id">
  <app-filter-set>
    <div app-search-filter></div>
    <div app-search-button></div>
  </app-filter-set>
</app-datalistview> 